var map = {
	"./add-hints.png": 4776,
	"./add.png": 1742,
	"./blocked.png": 7942,
	"./bronze-medal.png": 7664,
	"./buy-hints-header.png": 8574,
	"./challenge-demo.png": 2678,
	"./challenges-error.png": 5146,
	"./challenges-icon.png": 8276,
	"./challenges-success.png": 644,
	"./challenges.png": 3546,
	"./experience-points.png": 7630,
	"./gold-medal.png": 1747,
	"./grafica.png": 8216,
	"./hints.png": 5404,
	"./horse-active.png": 4820,
	"./horse.png": 5342,
	"./level.png": 3424,
	"./question-icons.png": 6399,
	"./ranking-main.png": 9281,
	"./ranking.png": 8608,
	"./silver-medal.png": 2386,
	"./trophy-active.png": 7931,
	"./trophy.png": 5885,
	"./user.png": 4688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8415;